import { IconChevronDown, IconLayoutList } from "@tabler/icons-react";
import type { MenuProps } from "antd";
import { Button, Dropdown, Menu } from "antd";
import { useWorkspaces } from "@/common/artemis-operations/workspaces";
import type { Workspace } from "@/common/model";
import { toLabel } from "@/common/utils";
import { CustomIcon } from "../base";

export default function WorkspaceSelector({
	activeId,
	collapsed,
	onChange,
}: {
	/** The workspace to show as selected — the current route's workspace. */
	activeId?: string;
	collapsed?: boolean;
	onChange?: (workspace: Workspace) => void;
}) {
	const { data: workspaces } = useWorkspaces();
	// Reflect the active (routed) workspace, not just the first one.
	const selected =
		workspaces?.find((w) => w?.id === activeId) ?? workspaces?.[0];

	const workspaceItems: MenuProps["items"] = workspaces
		?.filter((ws): ws is NonNullable<Workspace> => ws != null)
		.map((ws) => ({
			key: ws.id,
			label: toLabel(ws.name),
			onClick: () => onChange?.(ws),
		}));

	if (collapsed) {
		// Icon-only trigger; the workspace list flies out to the right (same as the collapsed nav).
		return (
			<Menu
				mode="inline"
				inlineCollapsed
				selectedKeys={selected ? [selected.id] : []}
				style={{ border: "none", background: "transparent" }}
				items={[
					{
						key: "workspace-submenu",
						icon: <CustomIcon icon={IconLayoutList} />,
						label: selected?.name,
						children: workspaceItems,
					},
				]}
			/>
		);
	}

	return (
		<div
			style={{
				alignItems: "center",
				display: "flex",
			}}
		>
			<Dropdown
				menu={{ items: workspaceItems, selectedKeys: [selected?.id || ""] }}
				trigger={["click"]}
				placement="bottomLeft"
			>
				<Button
					type="text"
					style={{
						width: "100%",
						justifyContent: "space-between",
						padding: "0 8px",
						alignItems: "center",
					}}
				>
					<CustomIcon icon={IconLayoutList} />
					<span
						style={{
							flex: 1,
							textAlign: "left",
							overflow: "hidden",
							// textOverflow: "ellipsis",
						}}
					>
						{selected?.name}
					</span>
					<IconChevronDown size={14} stroke={1.5} />
				</Button>
			</Dropdown>
		</div>
	);
}
